import { useFormContext } from "react-hook-form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import { Label } from "@radix-ui/react-label";
import { cn } from "@/lib/utils"; // opcional, si usas Tailwind con shadcn
import {
  Calendar,
  Home,
  IdCard,
  Mail,
  MapPin,
  Percent,
  Phone,
  User,
  Users,
} from "lucide-react";

type Option = {
  label: string;
  value: string;
};
type OptionNumber = {
  label: string;
  value: number;
};

interface SelectFieldProps {
  name: string;
  label: string;
  placeholder?: string;
  options?: Option[];
  optionsNumber?: OptionNumber[];
  disabled?: boolean;
  icon?: string;
}

export default function SelectField({
  name,
  label,
  placeholder,
  options,
  optionsNumber,
  disabled = false,
  icon,
}: SelectFieldProps) {
  const { formState, getFieldState, watch, setValue } = useFormContext();
  const { error } = getFieldState(name, formState);

  return (
    <div>
      <Label
        htmlFor={name}
        className="flex items-center gap-2 text-[var(--color-z-blue)]"
      >
        {icon === "users" ? (
          <Users className="h-4 w-4 text-[#91bfe3]" />
        ) : icon === "idcard" ? (
          <IdCard className="h-4 w-4 text-[#91bfe3]" />
        ) : icon === "user" ? (
          <User className="h-4 w-4 text-[#91bfe3]" />
        ) : icon === "calendario" ? (
          <Calendar className="h-4 w-4 text-[#91bfe3]" />
        ) : icon === "email" ? (
          <Mail className="h-4 w-4 text-[#91bfe3]" />
        ) : icon === "fono" ? (
          <Phone className="h-4 w-4 text-[#91bfe3]" />
        ) : icon === "porcentaje" ? (
          <Percent className="h-4 w-4 text-[#91bfe3]" />
        ) : icon === "mapa" ? (
          <MapPin className="h-4 w-4 text-[#91bfe3]" />
        ) : icon === "home" ? (
          <Home className="h-4 w-4 text-[#91bfe3]" />
        ) : (
          <Users className="h-4 w-4 text-[#91bfe3]" />
        )}
        {label} <span className="text-destructive">*</span>
      </Label>

      <Select
        disabled={disabled}
        value={watch(name) || ""}
        onValueChange={(newValue) => {
          setValue(name, newValue, {
            shouldValidate: true,
            shouldDirty: true,
          });
        }}
      >
        <SelectTrigger
          className={cn(
            "form-control",
            error && "border-red-500 focus:ring-red-500"
          )}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options && options.length > 0
            ? options.map((opt) => (
                <SelectItem key={opt.value} value={opt.value}>
                  {opt.label}
                </SelectItem>
              ))
            : optionsNumber?.map((opt) => (
                <SelectItem key={opt.value} value={opt.value.toString()}>
                  {opt.label}
                </SelectItem>
              ))}
        </SelectContent>
      </Select>

      {error && <p className="text-sm text-red-500">{error.message}</p>}
    </div>
  );
}
